var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('user.fields.phoneNumber'),"hint":_vm.$t('user.fields.phoneNumerHint'),"persistent-hint":"","prepend-icon":"mdi-phone","rules":_vm.validate ? _vm.phoneNumberRules : []},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }